import {
  useReactTable,
  getCoreRowModel,
  createColumnHelper,
} from "@tanstack/react-table";
import { Reminder } from "../../Clients/reminds";
import Table from "../../Components/Table/Table";
import { useRemindersContext } from "../../Contexts/Reminders.Context";
import { Temporal } from "@js-temporal/polyfill";
import { Remove } from "../../Icons/Remove";

const columnHelper = createColumnHelper<Reminder>();

const defaultColumns = [
  columnHelper.accessor("description", {
    header: "Item",
  }),
  columnHelper.accessor("deadline" as any, {
    header: "Deadline",
    cell: ({ cell }) => {
      return <span>{prettifyDate(cell.getValue())}</span>;
    },
  }),
  columnHelper.display({
    id: "actions",
    header: "Actions",
    cell: (props) => {
      return <DeleteButton id={props.row.original.id} />;
    },
  }),
];
export const RemindersTable = () => {
  const { data = [] } = useRemindersContext();

  const table = useReactTable({
    data,
    columns: defaultColumns,
    getCoreRowModel: getCoreRowModel(),
  });

  return <Table table={table}></Table>;
};

const prettifyDate = (utcString: string) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const instant = Temporal.Instant.from(utcString);
  const zoned = instant.toZonedDateTimeISO(timeZone);

  return zoned.toLocaleString(undefined, {
    dateStyle: "long",
    timeStyle: "short",
  });
};

const DeleteButton: React.FC<{ id: number | undefined }> = ({ id }) => {
  const { deleteReminder } = useRemindersContext();

  const handleDelete = () => {
    if (id) deleteReminder(id);
  };

  return <Remove onRemove={handleDelete} />;
};
